import { render, staticRenderFns } from "./RollCurtainsPage.vue?vue&type=template&id=5d0a68f8&scoped=true&"
import script from "./RollCurtainsPage.vue?vue&type=script&lang=js&"
export * from "./RollCurtainsPage.vue?vue&type=script&lang=js&"
import style0 from "./RollCurtainsPage.vue?vue&type=style&index=0&id=5d0a68f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0a68f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/wouter/apps/go02/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSlider } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {VApp,VBtn,VCard,VCardText,VCardTitle,VContainer,VFlex,VForm,VIcon,VLayout,VSlider,VSpacer,VTextField,VToolbar})
